import { FeedItem, ParentIncident } from '../../types';

export type UpdateItem =
  | { kind: 'MOMENT' | 'OBSERVATION'; id: string; at: string; feed: FeedItem }
  | { kind: 'INCIDENT'; id: string; at: string; incident: ParentIncident };

/**
 * One list for the Updates page: the child's feed (moments + observations,
 * cursor-paged, newest first) with the child's incident reports interleaved
 * by time. The feed is paged and the incidents are not, so an incident is
 * shown only once every feed item newer than it has been loaded — otherwise
 * it would appear above items that arrive on the next page. Once the feed is
 * exhausted every remaining incident is shown.
 *
 * Timestamps are UTC ISO strings from the API, so they compare lexically.
 */
export function mergeUpdates(
  feedItems: FeedItem[],
  incidents: ParentIncident[],
  feedExhausted: boolean
): UpdateItem[] {
  const oldestLoaded = feedItems.length ? feedItems[feedItems.length - 1].createdAt : null;
  const visibleIncidents = incidents.filter((i) =>
    feedExhausted ? true : oldestLoaded !== null && i.occurredAt >= oldestLoaded
  );
  const items: UpdateItem[] = [
    ...feedItems.map((f) => ({ kind: f.kind, id: f.id, at: f.createdAt, feed: f }) as UpdateItem),
    ...visibleIncidents.map((i) => ({ kind: 'INCIDENT' as const, id: i.id, at: i.occurredAt, incident: i })),
  ];
  // Newest first; Array.prototype.sort is stable, so equal timestamps keep input order.
  return items.sort((a, b) => b.at.localeCompare(a.at));
}
